export var npsDetailsMapper = function (response) {
    if (response)
        return response.map(function (item) {
            return {
                monthYear: item.monthyear,
                ratingReason: item.ratingReason,
                ratingReasonData: item.ratingReasonData,
            };
        });
    return {};
};
